export default {
  SET_DASHBOARD_STATS(state, stats) {
    state.dashboardStats = stats;
  },

  SET_STATUS_SUMMARY(state, v) {
    state.statusSummary = v;
  },

  SET_RESPONSE_CODES(state, codes) {
    state.responseCodes = Array.isArray(codes) ? codes : [];
  },

  SET_PERIODS_LOADING(state, v) {
    state.periods.loading = v;
  },

  SET_PERIODS(state, { data, pagination }) {
    state.periods.data = data;
    state.periods.pagination = { ...state.periods.pagination, ...pagination };
  },

  SET_CURRENT_PERIOD(state, period) {
    state.currentPeriod = period;
  },

  CLEAR_CURRENT_PERIOD(state) {
    state.currentPeriod = null;
  },

  SET_WIZARD_STEP(state, step) {
    state.wizard.step = step;
  },

  SET_WIZARD_MODE(state, mode) {
    state.wizard.mode = mode;
  },

  SET_WIZARD_PERIOD_ID(state, id) {
    state.wizard.periodId = id;
  },

  SET_WIZARD_FORM_DATA(state, { step, data }) {
    state.wizard.formData[`step${step}`] = data;
  },

  SET_WIZARD_DIRTY(state, v) {
    state.wizard.isDirty = v;
  },

  RESET_WIZARD(state) {
    state.wizard = {
      step: 1,
      mode: "create",
      periodId: null,
      formData: { step1: {}, step2: {}, step3: {}, step4: {} },
      validation: { step1: false, step2: false, step3: false, step4: false },
      isDirty: false,
    };
  },

  SET_RUNS_LOADING(state, v) {
    state.runs.loading = v;
  },

  SET_RUNS(state, { data, pagination }) {
    state.runs.data = data;
    state.runs.pagination = { ...state.runs.pagination, ...pagination };
  },

  SET_CURRENT_RUN(state, run) {
    state.currentRun = run;
  },

  SET_RUN_RESULTS(state, { data, pagination }) {
    state.runResults.data = data;
    state.runResults.pagination = {
      ...state.runResults.pagination,
      ...pagination,
    };
  },

  SET_RUN_PROGRESS(state, progress) {
    state.runProgress = progress;
  },

  SET_POLLING_INTERVAL(state, id) {
    state.pollingInterval = id;
  },

  SET_POLLING_TIMED_OUT(state, v) {
    state.pollingTimedOut = v;
  },

  CLEAR_POLLING(state) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval);
    }
    state.pollingInterval = null;
  },

  SET_SCORE_CHANGE_REQUESTS(state, list) {
    state.scoreChangeRequests = list || [];
  },

  SET_SCORE_CHANGE_DIALOG(state, v) {
    state.scoreChangeDialog = v;
  },

  SET_CURRENT_ENTITY(state, customer) {
    state.currentEntity = customer;
  },

  SET_ENTITY_HISTORY_LOADING(state, v) {
    state.entityHistory.loading = v;
  },

  SET_ENTITY_HISTORY(state, { data, total }) {
    state.entityHistory.data = data;
    state.entityHistory.total = total != null ? total : 0;
  },

  SET_ENTITY_LIVE_DATA(state, data) {
    state.entityLiveData = data;
  },

  OPEN_RESULT_MODAL(state, resultId) {
    state.resultModal.open = true;
    state.resultModal.resultId = resultId;
  },

  SET_RESULT_MODAL_DATA(state, data) {
    state.resultModal.data = data;
  },

  CLOSE_RESULT_MODAL(state) {
    state.resultModal = { open: false, resultId: null, data: null };
  },

  SET_TOAST(state, toast) {
    state.toast = toast;
  },

  CLEAR_TOAST(state) {
    state.toast = null;
  },
};
